<template>
    <footer>
        <div class="footer-content">
            <div class="footer-top">
                <div class="branding">
                    <router-link class="brand" :to="{ name: 'home' }">
                        <span class="brand-text"><span class="brand">Brand</span><span class="ratio">Ratio</span></span>
                    </router-link>
                    <p class="brand-tagline">Monitora e migliora il tuo brand</p>
                </div>
                <div class="footer-links">
                    <div class="link-group">
                        <h3>Prodotto</h3>
                        <ul>
                            <li><router-link :to="{ name: 'product' }">Demo</router-link></li>
                            <li><router-link :to="{ name: 'Sessioni' }">Sessioni</router-link></li>
                        </ul>
                    </div>
                    <div class="link-group">
                        <h3>Azienda</h3>
                        <ul>
                            <li><a href="mailto:ai@brandratio.it">Contattaci</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="footer-bottom">
                <div class="contact-info">
                    <a href="mailto:ai@brandratio.it" class="email-link">
                        <span class="email-icon">✉</span>
                        ai@brandratio.it
                    </a>
                </div>
                <div class="copyright">
                    © 2024 BrandRatio. Tutti i diritti riservati.
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'FooterPage'
}
</script>

<style lang="scss" scoped>
footer {
    background-color: #09172b;
    padding: 4rem 0 2rem;
    color: #fff;
    position: relative;
    width: 100%;
}

.footer-content {
    max-width: 1920px;
    margin: 0 auto;
    padding: 0 2rem;
}

.footer-top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 3rem;
    gap: 4rem;
}

.branding {
    flex: 0 0 300px;

    .brand {
        text-decoration: none;
        display: block;
        margin-bottom: 1rem;
    }

    .brand-text {
        font-size: 2.5rem;
        color: #fff;
        letter-spacing: -0.5px;
        display: inline-block;

        .brand {
            font-weight: 700;
            display: inline;
        }

        .ratio {
            font-weight: 400;
            display: inline;
        }
    }

    .brand-tagline {
        font-size: 1rem;
        color: rgba(255, 255, 255, 0.7);
        margin-top: 0.5rem;
    }
}

.footer-links {
    display: flex;
    gap: 4rem;
    flex: 1;
    justify-content: flex-end;
}

.link-group {
    h3 {
        font-size: 1.1rem;
        font-weight: 600;
        margin-bottom: 1.5rem;
        color: #fff;
    }

    ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    li {
        margin-bottom: 0.75rem;
    }

    a {
        color: rgba(255, 255, 255, 0.7);
        text-decoration: none;
        transition: color 0.3s ease;
        font-size: 0.95rem;

        &:hover {
            color: #56BCEE;
        }
    }
}

.footer-bottom {
    padding-top: 2rem;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.contact-info {
    .email-link {
        color: rgba(255, 255, 255, 0.7);
        text-decoration: none;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        transition: color 0.3s ease;

        &:hover {
            color: #56BCEE;
        }
    }

    .email-icon {
        font-size: 1.2rem;
    }
}

.copyright {
    color: rgba(255, 255, 255, 0.5);
    font-size: 0.9rem;
}

@media (max-width: 1024px) {
    .footer-top {
        flex-direction: column;
        gap: 2rem;
    }

    .branding {
        flex: 0 0 auto;
    }

    .footer-links {
        justify-content: flex-start;
        flex-wrap: wrap;
        gap: 2rem;
    }
}

@media (max-width: 768px) {
    footer {
        padding: 3rem 0 1.5rem;
    }

    .footer-content {
        padding: 0 1rem;
    }

    .footer-links {
        flex-direction: column;
        gap: 1.5rem;
    }

    .footer-bottom {
        flex-direction: column;
        gap: 1rem;
        text-align: center;
    }
}
</style>
